module.exports = __webpack_public_path__ + "static/media/trip-to-nowhere.32f505fe.jpg";